import type { BlockType } from '@assembly-web/services';
import {
  ArrowUpTrayIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  GifIcon,
  TrophyIcon,
  UserIcon,
} from '@heroicons/react/24/outline';

import { TextStyle } from '../../../DesignSystem/Feedback/TextStyle';
import { GaugeIcon, LinkedScale, TextAlignLeft } from '../../../Icons';

export type Props = {
  type: BlockType;
  index: number;
};

function Icon({ type }: { type: BlockType }) {
  switch (type) {
    case 'DROPDOWN':
      return <ChevronDownIcon className="stroke-gray-9" />;
    case 'SCALE':
      return <LinkedScale className="text-gray-9" />;
    case 'OPEN_ENDED':
      return <TextAlignLeft className="fill-gray-9" />;
    case 'TROPHIES':
      return <TrophyIcon className="stroke-gray-9" />;
    case 'PERSON_SELECTOR':
      return <UserIcon className="stroke-gray-9" />;
    case 'GIF':
      return <GifIcon className="stroke-gray-9" />;
    case 'FILE_UPLOAD':
      return <ArrowUpTrayIcon className="stroke-gray-9" />;
    case 'MULTI_CHOICE':
      return <CheckCircleIcon className="stroke-gray-9" />;
    case 'NPS':
      return <GaugeIcon />;
    case 'GIVE_POINTS_STACK':
      return <TrophyIcon className="stroke-gray-9" />;
    default:
      return null;
  }
}

export function BlockIndicator({ index, type }: Props) {
  return (
    <div className="flex items-center [&_svg]:h-4 [&_svg]:w-4">
      <Icon type={type} />
      <TextStyle
        className="block min-w-[20px] text-center"
        variant="sm-bold"
        as="span"
      >
        {index}
      </TextStyle>
    </div>
  );
}
